<template>
	<div :id="baseId" class="creators-showcase-panel d-flex flex-column">
		<div class="creators-showcase-panel-carousel d-flex flex-column">
			<div class="slide_header">
				<h1> All The Features You Need </h1>
				<h2> Stan simplifies entrepreneurship with all-in-one tools, unmatched support, and zero tech hassle, so Creators can thrive. </h2>
			</div>
			<div class="scroller" ref="scroller" @mouseenter="toggleScrolling(false)" @mouseleave="toggleScrolling(true)">
				<ul class="scroll__inner" ref="scrollerInner">
					<li class="highlight">
						<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-1.png') + ')'}">
							<div class="expo anim">
								<h1> Community </h1>
								<p>
									Connect with your followers with a private, branded community.
								</p>
							</div>
						</div>
					</li>

					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-2.png') + ')'}">
								<div class="expo anim">
									<h1> Digital Products </h1>
									<p>
										Create and sell eBooks, templates,  guides, and more.
									</p>
								</div>
							</div>
					</li>

					<div class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-3.png') + ')'}">
								<div class="expo anim">
									<h1> Calendar Bookings </h1>
									<p>
										Host personalized 1:1 sessions through easy coaching calls.
									</p>
								</div>
							</div>
					</div>

					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-4.png') + ')'}">
								<div class="expo anim">
									<h1> Lead Magnets </h1>
									<p>
										Attract and grow your email list with digital freebies.
									</p>
								</div>
							</div>
					</li>

					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-5.png') + ')'}">
								<div class="expo anim">
									<h1> Webinars </h1>
									<p>
										Share your expertise and grow your audience with webinars.
									</p>
								</div>
							</div>
					</li>

					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-6.png') + ')'}">
								<div class="expo anim">
									<h1> Analytics </h1>
									<p>
										Track your sales and get customer insights in real time.
									</p>
								</div>
							</div>
					</li>

					<div class = 'highlight'>
						<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-7.png') + ')'}">
							<div class="expo anim">
								<h1> Links & URLs </h1>
								<p>
									Make it easy to share with one link to all your offerings.
								</p>
							</div>
						</div>
					</div>

					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-8.png') + ')'}">
								<div class="expo anim">
									<h1> Courses </h1>
									<p>
										Create and sell courses that educate and empower learners.
									</p>
								</div>
							</div>
					</li>


					<li class="highlight">
							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-9.png') + ')'}">
								<div class="expo anim">
									<h1> Subscriptions </h1>
									<p>
										Offer memberships to build loyalty and steady revenue.
									</p>
								</div>
							</div>
					</li>

					<li class="highlight">

							<div class="img" :style="{'background-image': 'url(' + require('@/assets/images/home/v8/feature-sm-10.png') + ')'}">
								<div class="expo anim">
									<div class = 'top'>
										<h1> Auto DMs </h1>
										<h2> Coming Soon </h2>
									</div>
									<p>
										Automate your Instagram DMs to save time and engage followers.
									</p>
								</div>
							</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed, defineProps, onMounted, ref } from 'vue'

	const props = defineProps({
		id: {
			type: [String, Number],
		},
		activeComponent: { type: Boolean },
	})

	const baseId = computed(() => `${props.id}`)
	const scroller = ref()
	const scrollerInner = ref()

	onMounted(() => {
		if (true) {
			addAnimation()
		}
	})
	function addAnimation() {
		scroller.value?.setAttribute('data-animated', true)
		const scrollerChildren = Array.from(scrollerInner.value.children)
		scrollerChildren.forEach(item => {
			const duplicateItem = item.cloneNode(true)
			duplicateItem.setAttribute('aria-hidden', true)
			scrollerInner.value.appendChild(duplicateItem)
		})
	}
	function toggleScrolling(keepScrolling) {
		scroller.value?.setAttribute('data-animated', keepScrolling)
	}

</script>

<style lang="scss" scoped>
	.creators-showcase-panel {
		background: white;
		padding-top: 30px;
		position: relative;
	}


	.highlight {
		display: flex;
		align-items: center;
		margin-right: 40px;

		&:nth-child(even) {
			transform: translateY(var(--parallax-s1-1));
		}

		&:nth-child(odd) {
			transform: translateY(var(--parallax-s1-2));
		}

		&.final {
			padding-right: 100px;
		}

		.img {
			height: 460px;
			width: 320px;
			border-radius: 15px;
			box-shadow: -10px 10px 30px rgba(black, 0.1);
			background-position: center center;
			background-size: cover;
			position: relative;


			height: 260px;
			width: 420px;
		}


		.expo{
			position: absolute;
			bottom: 0;
			left: 0;
			color: #081144;
			border-radius: 15px;
			width: 340px;
			height: 100%;
			padding: 25px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			width: 300px;

			h1 {
				font-size: 38px;
				font-weight: 700;
				margin-bottom: 6px;
				letter-spacing: -0.5px;
				line-height: 100%;
				width: calc(100% - 25px);
			}

			h2{
				font-size: 14px;
				font-weight: 700;
				background: white;
				border-radius: 16px;
				padding: 6px 10px 7px 10px;
				width: fit-content;
				margin-top: 20px;
				box-shadow: 0 4px 12px rgba(#00106D, 0.05);
			}

			p{
				font-size: 22px;
				font-weight: 300;
				line-height: 120%;
				letter-spacing: -0.2px;
				width: 90%;
				margin: 0;
				color: rgba(black, 0.5);
			}

		}
	}

	.profile {
		width: 230px;
		border-radius: 20px;
		box-shadow: 0px 20px 60px rgba(#00106d, 0.1);
	}
	.store {
		width: 220px;
		border-radius: 40px;
		box-shadow: -10px 10px 30px rgba(black, 0.1);
		z-index: 5 !important;
		transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
	}
	.offset {
		transform: translateX(-100px);
	}
	.offset :hover {
		transform: scale(1.02);
	}
	.slide_highlight {
		padding-bottom: 0;
		background-color: none;
	}

	@media screen and (max-width: 767px) {
		.scroll {
			padding-left: 80px !important;

		}
		.creators-showcase-panel{
			margin-bottom: -32px;
		}

		.slide_header{
			padding: 0;
		}

		.highlight {

			.expo {
				width: 70vw;
				padding: 20px;

				width: 52vw;
			}
			.img {
				width: 64vw;
				height: 92vw;

				width: 72vw;
				height: 45vw;

				.expo {
					padding: 20px;
					h1 {
						font-size: 24px;
						margin-bottom: 5px;
					}
					h2 {
						padding: 2px 5px 3px 5px;
						margin-top: 10px;
						font-size: 10px;
						margin-bottom: 5px;
					}
					p{
						font-size: 12px;
						letter-spacing: 0;
						padding-bottom: 5px;
					}
				}
			}
		}
	}

	.scroller {
		max-width: 100%;
		overflow-y: hidden;
		position: relative;
		transform: translateX(-50%);
		left: 50%;
	}

	.scroller .scroll__inner {
		width: max-content;
		animation: scroll 60s linear infinite;
		animation-play-state: paused;
	}

	.scroller[data-animated='true'] .scroll__inner {
		animation-play-state: running;
	}

	.scroll__inner {
		display: flex;
		gap: 0px;
		padding: 80px 30px 60px 100px;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	.scroll__inner::-webkit-scrollbar {
		display: none;
	}

	@keyframes scroll {
		to {
			transform: translate(calc(-50% + 67px));
		}
	}

	@media screen and (max-width: 800px){
		.slide_carousel{
			padding: 32px 0;
		}
	}

</style>
